import ClientSettings from './ClientSettings';

export default ClientSettings;
